import React from "react";
import {
  TrendingUp,
  Target,
  Mail,
  Users,
  BarChart,
  Megaphone,
  PieChart,
  Zap,
} from "lucide-react";
import IndustryPageTemplate from "../components/IndustryPageTemplate";

const SERVICE_OFFERINGS = [
  {
    title: "CRM Development",
    description: "Build custom CRM systems for lead and customer management",
    icon: Users,
  },
  {
    title: "Marketing Automation",
    description: "Develop automated campaigns, email, and nurture workflows",
    icon: Mail,
  },
  {
    title: "Sales Enablement",
    description: "Create tools for sales teams to close deals faster",
    icon: Target,
  },
  {
    title: "Analytics Dashboards",
    description: "Real-time reporting for marketing and sales performance",
    icon: BarChart,
  },
  {
    title: "Lead Generation",
    description: "Build landing pages, forms, and lead capture systems",
    icon: Megaphone,
  },
  {
    title: "Campaign Management",
    description: "Multi-channel campaign planning and execution tools",
    icon: Zap,
  },
  {
    title: "Attribution & ROI",
    description: "Track marketing attribution and return on investment",
    icon: PieChart,
  },
  {
    title: "Integration Services",
    description: "Connect marketing tools with CRM and business systems",
    icon: TrendingUp,
  },
];

const STATS = [
  { value: "200+", label: "MarTech Projects" },
  { value: "50M+", label: "Leads Processed" },
  { value: "3x", label: "Avg ROI Increase" },
  { value: "24/7", label: "Automation" },
];

const SalesMarketingIndustryPage = () => {
  return (
    <IndustryPageTemplate
      industrySlug="sales-marketing"
      industryTitle="Sales"
      industrySubtitle="& Marketing"
      heroDescription="Accelerating revenue growth with powerful CRM systems, marketing automation platforms, and sales enablement tools that help teams connect with customers and close deals."
      themeColor="#f43f5e"
      themeColorLight="#fb7185"
      themeGradient="linear-gradient(135deg, #881337 0%, #be123c 50%, #f43f5e 100%)"
      HeroIcon={TrendingUp}
      stats={STATS}
      serviceOfferings={SERVICE_OFFERINGS}
      heroImage={
        "https://images.unsplash.com/photo-1434626881859-194d67b2b86f?q=80&w=1174&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
      }
    />
  );
};

export default SalesMarketingIndustryPage;
